import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import './Advantages.css';

const Advantages = () => {
  const { t } = useTranslation();

  // Получаем массив items из переводов
  const items = t('advantages.items');
  const advantagesList = Array.isArray(items) ? items : [];

  return (
    <section className="section section-dark advantages">
      <div className="container">
        <h2 className="section-title" style={{ color: '#fff', textAlign: 'center' }}>
          {t('advantages.title')}
        </h2>
        <p className="section-subtitle" style={{ textAlign: 'center', margin: '0 auto 48px' }}>
          {t('advantages.subtitle')}
        </p>

        <div className="advantages__grid">
          {advantagesList.map((item, index) => (
            <div
              key={index}
              className="advantages__card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="advantages__icon">{item.icon}</div>
              <h3 className="advantages__title">{item.title}</h3>
              <p className="advantages__text">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advantages;